import { CtxMapV2Provider } from 'components/mapV2/contexts/CtxMapV2';
import { MapV2 } from 'components/mapV2/MapV2';
import { useViewMapQueryParams } from 'hooks/map/useViewMapQueryParams';
import { useCustomMapPage } from 'pages/custom/shared/CustomMapPage/useCustomMapPage';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext, useEffect } from 'react';
import { useParams } from 'react-router';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'yet-another-react-lightbox/styles.css';

interface Props {
    className?: string;
}

export const ViewMapPageV2 = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);
    const { id } = useParams() as { id: string };
    const queryParamData = useViewMapQueryParams();
    useCustomMapPage(id, { skip: false });

    useEffect(() => {
        if (queryParamData.language) {
            Localization.setLanguage(queryParamData.language);
        }
    }, [queryParamData, queryParamData.language]);

    if (!ctxView.map || !ctxView.allDetails || !ctxView.allMarkers) {
        return null;
    }

    return (
        <S_ViewMapPageV2 className={props.className} $listEnabled={ctxView.map.showList}>
            <CtxMapV2Provider>
                <MapV2 />
            </CtxMapV2Provider>
        </S_ViewMapPageV2>
    );
};

const S_ViewMapPageV2 = styled(S_PageStyle)<{ $listEnabled: boolean }>`
    @media only screen and (max-width: 1259px) {
        .mapboxgl-ctrl-bottom-right {
            right: ${(props) => (props.$listEnabled ? '-5px' : '35px')};
            margin-bottom: ${(props) => (props.$listEnabled ? '1000px' : '0px')};
        }
        .mapboxgl-ctrl-bottom-left {
            left: -10px;
            margin-bottom: ${(props) => (props.$listEnabled ? '85px' : '-5px')};
        }
        .mapbox-geolocate {
            margin-bottom: ${(props) => (props.$listEnabled ? '112px' : '-5px')};
            margin-right: -12px;
        }
    }
`;
